(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('[data-header]');
      this.toggle = this.querySelector('[data-menu-toggle]');
      this.nav = this.querySelector('[data-mobile-nav]');
      if (!this.toggle || !this.nav) return;

      this.toggle.addEventListener('click', this.onToggle);
      document.addEventListener('keydown', this.onKeydown);

      // Close the panel when the viewport grows past the mobile breakpoint.
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.desktop.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      this.desktop?.removeEventListener('change', this.onBreakpoint);
      document.body.style.removeProperty('overflow');
    }

    onToggle = () => {
      this.isOpen ? this.close() : this.open();
    };

    onKeydown = (event) => {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.toggle.focus();
      }
    };

    onBreakpoint = (event) => {
      if (event.matches && this.isOpen) this.close();
    };

    get isOpen() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    open() {
      this.nav.hidden = false;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.header.setAttribute('data-nav-open', '');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.nav.hidden = true;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.header.removeAttribute('data-nav-open');
      document.body.style.removeProperty('overflow');
    }
  }

  if (!customElements.get('site-header')) customElements.define('site-header', SiteHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-showcase"] && !Shopify.designMode) return;
  try {
    
  class ToastRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-toast]'));
      if (this.items.length === 0) return;

      this.index = 0;
      this.items[0].setAttribute('data-active', '');

      if (this.items.length === 1 || window.theme?.prefersReducedMotion()) return;

      const interval = Number(this.dataset.interval) || 3900;

      // Rotating only while visible keeps a background tab from doing work.
      this.observer = new IntersectionObserver((entries) => {
        entries[0].isIntersecting ? this.start(interval) : this.stop();
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
    }

    start(interval) {
      if (this.timer) return;
      this.timer = setInterval(() => this.advance(), interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    advance() {
      this.items[this.index].removeAttribute('data-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].setAttribute('data-active', '');
    }
  }

  if (!customElements.get('toast-rotator')) customElements.define('toast-rotator', ToastRotator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-plans"] && !Shopify.designMode) return;
  try {
    
  class PlanSwitcher extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('[data-interval-option]'));
      if (this.options.length === 0) return;

      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const option = event.target.closest('[data-interval-option]');
      if (!option) return;

      const interval = option.dataset.intervalOption;
      this.dataset.interval = interval;
      this.options.forEach((button) => {
        button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
      });
    };
  }

  if (!customElements.get('plan-switcher')) customElements.define('plan-switcher', PlanSwitcher);

  } catch(e) { console.error(e); }
})();
})();
